import React from 'react'
import EmailSuccess from '../../../Components/Molecules/ForgotPassword/EmailSuccess'

function EmailSuccessTemplate() {
  return (
    <EmailSuccess />
  )
}

export default EmailSuccessTemplate